import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters' // 导入响应的模块，*相当于引入了这个组件下所有导出的事例
import * as actions from './actions'
import * as mutations from './mutations'


Vue.use(Vuex)
// 首先声明一个需要全局维护的状态 state,比如 我这里举例的resturantName
const state = {
    AllProductList: {},
    Childproductlist: localStorage.getItem('Childproductlist') || {},
    productname: localStorage.getItem('productname') || '',
    YwwLagre: localStorage.getItem('YwwLagre') || {},
    YwwpicRight: localStorage.getItem('YwwpicRight') || {},
    CustomUplod: localStorage.getItem('price') || {},
    logostylenumber: localStorage.getItem('sum') || '',
    logoColornumber: localStorage.getItem('name') || '',
    productlist: localStorage.getItem('productlist') || {},
    DesignList: localStorage.getItem('DesignList') || {},
    Xiancai: localStorage.getItem('Xiancai') || {},
    Baozhuang: localStorage.getItem('Baozhuang') || {},
    Pnumber: localStorage.getItem('Pnumber') || '',
    SelectDesign: localStorage.getItem('SelectDesign') || {},
    SumPrice: localStorage.getItem('SumPrice') || '',
    DesignMake: localStorage.getItem('DesignMake') || {},
    makelist: sessionStorage.getItem('makelist') || {},
    tabbarList: localStorage.getItem('tabbarList') || [],
    addinfo: localStorage.getItem('addinfo') || {},
    tokenid: localStorage.getItem('tokenid') || '',
    ukey: localStorage.getItem('ukey') || '',
    //  resturantName: '飞歌餐馆' // 默认值
    // id: xxx  如果还有全局状态也可以在这里添加
    // name:xxx
}

// 注册上面引入的各大模块
const store = new Vuex.Store({

    state: localStorage.getItem('state') ? JSON.parse(localStorage.getItem('state')) : {

        tabbarList: [
            {
                id: 1,
                name: "首页",
                tag: "index",
                active: "",
                show: '',
              
                routerlink: "/",
                childenMemu: []
            },
            {
                id: 2,
                name: "产品",
                tag: "product",
                active: "",
                show: 'active',
                routerlink: "",
                childshow: 2,
                childenMemu: []
            },
            {
                id: 3,
                name: "设计",
                tag: "design",
                active: "",
                show: '',
           
                routerlink: "/Design",
                childenMemu: [

                ]
            },
            {
                id: 4,
                name: "售后",
                tag: "after sale",
                active: "",
                show: '',
                routerlink: "",
              
                childenMemu: [
                    {
                        id: 1,
                        name: '售后说明'
                    },
                    {
                        id: 2,
                        name: '防伪查询'
                    },
                    {
                        id: 3,
                        name: '产品注册 '
                    },
                    {
                        id: 4,
                        name: '延保服务'
                    },
                    {
                        id: 5,
                        name: '升级改模'
                    },

                ]
            },
            {
                id: 5,
                name: "我的",
                tag: "member",
                active: "",
                show: '',
             
                routerlink: "",
                childenMemu: [

                ]
            }
        ],
        addinfo: {},
        productname: '混合单元系列',
        newum: '',
        tokenid:'',
        Childproductlist: {
            id:-1,
        },
        // img: require('@/assets/logo.png'),
        // YwwpicRight: require('@/assets/2019092409071518.png'),
        // YwwLagre: require('@/assets/Ywwright.png'),
        YwwpicRight: {},
        YwwLagre: {},
        // name: '',
        productlist: {},
        sum: 0,
        Xiancai: {
        },
        Baozhuang: {
        },
        Pnumber: 1,
        AllSum: 0,
        DesignList: {
            Description: " ",
            Name: "",
            Price: 0,
        },
        SumPrice: 0,
        SelectDesign: {},
        CustomUplod: {},
        logostylenumber: -1,
        logoColornumber: -1,
        DesignMake: {},
        ukey:0,
        makelist: {
            name: '',
            Kname: '',
            tel: '',
            address: '',
            express: '',
            agent: '',
        },
    },
    // 共同维护的一个状态，state里面可以是很多个全局状态
    getters,  // 获取数据并渲染
    actions,  // 数据的异步操作
    mutations  // 处理数据的唯一途径，state的改变或赋值只能在这里

})

export default store  // 导出store并在 main.js中引用注册。


// WEBPACK FOOTER //
// ./src/store/index.js